import { overlayStationVar } from '../variables'

const setOverlayStation = stationId => {
  overlayStationVar(stationId)
}

export { setOverlayStation }
